import axios from "axios";

export const axiosConfig = () => {
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.validateStatus = (status) => status < 500;
};
